import { Component } from 'react';
import Select from 'legacy/javascripts/components/select.es6.jsx';

class AgentFilter extends Component {
  render() {
    let filterTitleStyle = {
      margin: '15px 0',
      fontSize: '16px',
    };
    return (
      <div className="col-md-4">
        <h4 style={filterTitleStyle}>Team member name</h4>
        <Select
          id="employee_id"
          handler={this.props.handler}
          data={this.props.data}
          selected={this.props.selected}
        />
      </div>
    );
  }
}

export default AgentFilter;
